import React from 'react';

// import SummaryBlock from './SummaryBlock';
import SummaryBlockViewer from './SummaryBlock'
import SelectOpportunityTypeViewer from './SelectOpportunityTypes'
import InfoCardViewer from './InfoCards'
import AttachmentDocumentViewer from './AddDocuments'
import ClauseDetailsViewer from './ClauseDetails';
import MetaDataViewer from './MetaDataView'
import SupplementalInfoViewer from './SupplementalInfoView';
import SimpleTableViewer from './SimpleTable';
import UploadViewer from './Upload';

const RenderComponentBasedOnBlock = (props) => {
    const { block, blockState, blocks } = props

    const checkConditions = (conditions, blockState) => {

        // 1. No conditions? ✅ Always allow
        if (!conditions || conditions.length === 0) return true;

        let result = null;

        for (const cond of conditions) {
            const fieldValue = blockState?.[cond.selectedConditionDataElement];

            // 2. If blockState does not have this key → ✅ treat as not met
            if (fieldValue === undefined || fieldValue === null) continue;

            let isMet = false;
            switch (cond.selectedConditionOperator) {
                case "is_equals":
                    isMet = fieldValue === cond.value;
                    break;
                case "is_not_equals":
                    isMet = fieldValue !== cond.value;
                    break;
                case "contains":
                    isMet = Array.isArray(fieldValue) && fieldValue.includes(cond.value);
                    break;
                case "not_contains":
                    isMet = Array.isArray(fieldValue) && !fieldValue.includes(cond.value);
                    break;
                default:
                    isMet = true; // fallback safe allow
            }

            if (cond.selectedConditionClause === "or") {
                result = result === null ? isMet : result || isMet;
            } else if (cond.selectedConditionClause === "and") {
                result = result === null ? isMet : result && isMet;
            }
        }

        // If result is still null (none of the fields exist), default false
        return result === null ? false : result;
    };

    // Check if the block should be rendered based on conditions
    const shouldRenderBlock = checkConditions(block.conditions, blockState);

    console.log('checkConditions in RenderComponentBasedOnBlock 1', shouldRenderBlock);


    // If block has conditions and they're not met, don't render
    if (block.conditions && block.conditions.length > 0 && !shouldRenderBlock) {
        return null;
    }

    console.log('shouldRenderBlock', props.selectedStep, block);
    // Check if ClauseDetails should be rendered based on AddDocuments
    const shouldRenderClauseDetails = () => {
        console.log('shouldRenderClauseDetails', block.type, blocks, block);
        if (block.type === "clauseDetails") {
            if (block?.dependsOn) {
                const dependencyBlock = props?.selectedStep?.blocks?.find(b => b.type === block.dependsOn);
                return !!dependencyBlock;
            }
            else {
                return false
            }
        }
        return true;
    };

    // Additional check for ClauseDetails
    if (block.type === "clauseDetails" && !shouldRenderClauseDetails()) {
        return null;
    }

    const shouldRenderMetaDataView = () => {
        console.log('shouldRenderClauseDetails', block.type, blocks, block);
        if (block.type === "metaDataView") {
            if (block?.dependsOn) {
                const dependencyBlock = props?.selectedStep?.blocks?.find(b => b.type === block.dependsOn);
                return !!dependencyBlock;
            }
            else {
                return false
            }
        }
        return true;
    };

    // Additional check for ClauseDetails
    if (block.type === "metaDataView" && !shouldRenderMetaDataView()) {
        return null;
    }

    const canUserEdit = () => {

        console.log('canUserEdit', blockState?.["createdByName"], props.members?.name, blockState?.["createdByName"] === props.members?.name);


        if (blockState?.["status"] === "Rejected") {
            return false;
        }
        if (!blockState?.workflow && !blockState?.["status"] && !props.match.params.id) {
            return true;
        }
        if (!blockState?.workflow && blockState?.["status"] !== "Rejected" && blockState?.["createdByName"] === props.members?.name && props.match.params.id) {
            return true;
        }
     
        // if (!blockState?.workflow && blockState?.["status"] !== "Rejected") return true;
        // // If no workflow or no current respondent, allow editing (default behavior)
        // if (!blockState?.workflow?.currentRespondent?.id && blockState?.["status"] !== "Rejected") {
        //     return true;
        // }

        // If current user is the respondent, allow editing
        if (blockState?.workflow?.currentRespondent.id === props.members?._id && blockState?.["status"] !== "Rejected") {
            return true;
        }

        // Otherwise, user can only view
        return false;
    };

    const isEditable = canUserEdit();
    console.log('isEditable', isEditable);


    return (
        <React.Fragment>
            {
                (function () {
                    switch (block.type) {
                        case "summaryItems":
                            return <SummaryBlockViewer key={block.name} {...props} config={block.config} block={block} isEditable={isEditable} />
                            break;
                        case "simpleTableViewer":
                            return <SimpleTableViewer key={block.name} {...props} config={block.config} block={block} isEditable={isEditable} />
                            break;
                        case "selectOpportunityType":
                            return <SelectOpportunityTypeViewer key={block.name} {...props} config={block.config} block={block} isEditable={isEditable} />
                            break;
                        case "attachmentDocument":
                            return <AttachmentDocumentViewer key={block.name} {...props} config={block.config} isEditable={isEditable} />
                            break;
                        case "clauseDetails":
                            return <ClauseDetailsViewer key={block.name} {...props} config={block.config} isEditable={isEditable} />
                            break;
                        case "metaDataView":
                            return <MetaDataViewer key={block.name} {...props} config={block.config} isEditable={isEditable} />
                            break;
                        case "supplementalInfo":
                            return <SupplementalInfoViewer key={block.name} {...props} config={block.config} isEditable={isEditable} />
                            break;
                        case "infoCards":
                            return <InfoCardViewer key={block.name} {...props} config={block.config} isEditable={isEditable} />
                            break;
                        case "UploadViewer":
                            return <UploadViewer key={block.name} {...props} config={block.config} isEditable={isEditable} />
                            break;
                        default:
                            return null;
                    }
                })()
            }
        </React.Fragment>
    )
}

export default RenderComponentBasedOnBlock